import { useEffect, useState } from "react"
import { TabContent } from "../Tab/TabContent"
import { Tabs } from "../Tabs/Tabs"
import { useAppDispatch } from "../../app/hooks"
import { updateReportState } from "../../app/reducers/reportsSlice"
import { CardsToRemove } from "../CardsToRemove/CardsToRemove"
import { UpdateWbCards } from "../UpdateWbCards/UpdateWbCards"
import { UpdateWbMedia } from "../UpdateWbMedia/UpdateWbMedia"
import { WBTokenGuard } from "../WBTokenGuard/WBTokenGuard"

export const CardsManagerTabs = () => {
  const [activeTab, setActiveTab] = useState("tabcontent-removeCards")
  const dispatch = useAppDispatch()

  useEffect(() => {
    dispatch(updateReportState())
  }, [dispatch])

  return (
    <div className="h100 w100">
      <Tabs onChange={setActiveTab} activeTabIdent={activeTab} isVertical>
        <TabContent
          key={`tabcontent-removeCards`}
          name={`Удаление карточек WB`}
          ident={"removeCards"}
        >
          <WBTokenGuard>
            <CardsToRemove />
          </WBTokenGuard>
        </TabContent>
        <TabContent
          key={`tabcontent-cardsManager`}
          name={`Редактировать карточки WB`}
          ident={"cardsManager"}
        >
          <WBTokenGuard>
            <UpdateWbCards />
          </WBTokenGuard>
        </TabContent>
        <TabContent
          key={`tabcontent-mediaManager`}
          name={`Медиафайлы WB`}
          ident={"mediaManager"}
        >
          <WBTokenGuard>
            <UpdateWbMedia />
          </WBTokenGuard>
        </TabContent>
      </Tabs>
    </div>
  )
}
